module.exports = __webpack_public_path__ + "media/images/logos/rotpunkt-logo-og-a9276d7b5c607705b9c0fca4ee66423e.jpg";